import React, { useState, useRef, useEffect } from "react";
import "../Css/home.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Accordion, Button } from "react-bootstrap";
import Card from 'react-bootstrap/Card';
import quto from '../image/New Stud Dash/quote.46562a2f.webp';
import "../index.css";
import { Container, Row, Col } from "reactstrap";
// import tnth from "../image/10th_student.png";
// import twth from "../image/12th_student.png";
// import clg from "../image/college_student.png";
import t1 from "../image/testimonial_1.webp";
import t2 from "../image/testimonial_2.webp";
import t3 from "../image/testimonial_3.webp";
import t4 from "../image/testimonial_4.webp";
import t5 from "../image/testimonial_5.webp";
import t6 from "../image/testimonial_6.webp";
import t7 from "../image/testimonial_7.webp";
import t8 from "../image/testimonial_8.webp";
import t9 from "../image/testimonial_9.webp";
import t10 from "../image/testimonial_10.webp";
import t11 from "../image/testimonial_11.webp";
import t12 from "../image/testimonial_12.webp";
import t13 from "../image/testimonial_13.webp";
import t14 from "../image/testimonial_14.webp";
import s2pic1 from "../image/krish_lathiya.webp";
import s2pic2 from "../image/prem_stu.webp";
import s2pic3 from "../image/krish_vagadiya.webp";
import s2pic4 from "../image/Rucha.webp";
import s2pic5 from "../image/khushi.webp";
import s2pic6 from "../image/gresa.webp";
// import tick from "../image/yellow_tick.png";
import cross from "../image/cross.webp";
import sv from "../image/New Stud Dash/sv.webp";
// import canvas from "../image/image/canvas_stu.png";
import studvideo1 from "../image/video_1.webp";
import studvideo2 from "../image/video_2.webp";
import studvideo3 from "../image/video_3.webp";
import studvideo4 from "../image/video_4.webp";
import studvideo5 from "../image/video_5.webp";
import studvideo6 from "../image/video_6.webp";
import studvideo7 from "../image/video_7.webp";
import studvideo8 from "../image/video_8.webp";
// import fivestep from "../image/image/5_step_img.png";
import "@fortawesome/fontawesome-free/css/all.css";
import warning from '../image/New Stud Dash/warning.webp';
import running from '../image/New Stud Dash/running.webp';
import graduactions from '../image/New Stud Dash/graduationHat.webp';
import india from '../image/New Stud Dash/in.webp';
import thinking from '../image/New Stud Dash/thinking.webp';
import down_arrow from '../image/New Stud Dash/downArrow.webp';
import { MdOutlineStarPurple500 } from "react-icons/md";
import usa from '../image//New Stud Dash/us.webp';
import careersahi_video from '../image/New Stud Dash/ezgif-56a4995d118b43.mp4';
import about_image from '../image/New Stud Dash/about-us.webp';
import mentor1 from '../image/image/Industries Expert/1.webp';
import mentor2 from '../image/image/Industries Expert/2.webp';
import mentor3 from '../image/image/Industries Expert/3.webp';
import mentor4 from '../image/image/Industries Expert/4.webp';
import mentor5 from '../image/image/Industries Expert/5.webp';
import mentor6 from '../image/image/Industries Expert/6.webp';
import mentor7 from '../image/image/Industries Expert/7.webp';
import mentor8 from '../image/image/Industries Expert/8.webp';
import mentor9 from '../image/image/Industries Expert/9.webp';
import mentor10 from '../image/image/Industries Expert/10.webp';
import mentor11 from '../image/image/Industries Expert/11.webp';
import mentor12 from '../image/image/Industries Expert/12.webp';
import student_image from '../image/student.webp';
// import career_image from '../image/New Stud Dash/career image .jpg';
import vidhi from '../image/New Stud Dash/vidhi.webp';
import { FaWhatsapp } from "react-icons/fa";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay, FreeMode, Navigation } from "swiper/modules";
import { Link, useNavigate } from "react-router-dom";
import Features from "../component/Feature";
import Contact from "./Contact";
const Home = () => {
  const [isVideoVisible, setVideoVisible] = useState(false);
  const [isswiper_img, setisswiper_img] = useState(false);
  const navigate = useNavigate();
  const swiperRef = useRef(null);
  const handleImageClick = () => {
    setVideoVisible(true);
  };
  const [activeKey, setActiveKey] = useState("0");

  // Function to toggle the active key
  const toggleAccordion = (key) => {
    setActiveKey((prevKey) => (prevKey === key ? null : key));
  };
  // video
  const [videoboxOpen, setVideoboxOpen] = useState(false);
  const [currentVideo, setCurrentVideo] = useState(0);
  const openVideo = (videoUrl) => {
    const autoplayUrl = videoUrl.split("?")[0] + "?autoplay=1";
    setCurrentVideo(autoplayUrl);
    setVideoboxOpen(true);
  }
  const closeVideo = () => {
    setVideoboxOpen(false);
    if (swiperRef.current) {
      const swiper = swiperRef.current;
      swiper.params.autoplay.disableOnInteraction = false;
      swiper.params.autoplay.delay = 10;
      swiper.autoplay.stop();
      setTimeout(() => {
        swiper.update();
        swiper.autoplay.start();
        swiper.slideTo(swiper.realIndex);
      }, 500);
    }
  };
  // const swiper_img = (index) => {
  //   // If you click the same video that's open, it should close it (toggle behavior)
  //   if (isswiper_img === index) {
  //     setisswiper_img(null); // close it
  //   } else {
  //     setisswiper_img(index); // open the specific video
  //   }
  // };

  // ---------------Canvas-------
  // const features = [
  //   "વ્યક્તિગત અને સચોટ કરિયર માર્ગદર્શન",
  //   "વિવિધ સ્કોલરશીપનું માર્ગદર્શન",
  //   "વિદ્યાર્થીની શક્તિઓ, રુચિઓ, નબળાઈઓ ઓળખવી",
  //   "જોબ અને વ્યવસાયની તકો",
  //   "વિવિધ ફિલ્ડનું ઊંડાણપૂર્વક માર્ગદર્શન",
  //   "શિક્ષણ પાછળ કરેલ પૈસા, સમય અને મહેનતનું વળતર",
  //   "આવડત અને ક્ષમતાના આધારે કરિયરની પસંદગી",
  //   "કરીયરમાં સફળ થવા માટે વ્યક્તિગત ઈમ્પ્રુવમેન્ટ",
  //   "ફિલ્ડ અનુરૂપ કોલેજ પસંદ કરવી",
  //   "આવડત અને ક્ષમતા પ્રમાણે કરિયરની પસંદગી",
  //   "કરીયરમાં સફળ થવાના વિવિધ રસ્તાઓ",
  //   "આવતા 10 વર્ષનું કરિયર પ્લાનિંગ",
  // ];

  // ---------------- Delay change Heading home page1--------------
  const [content, setContent] = useState("");

  const messages = [
    "સાયન્ટિફિક કરિયર પ્લાનિંગ સાથે, પરફેક્ટ કરિયર ઓપ્શન શોધો.",
    "A School, College & Career Platform for Modern Students",
  ];
  useEffect(() => {
    const interval = setInterval(() => {
      setContent((prevContent) => {
        const currentIndex = messages.indexOf(prevContent);
        const nextIndex = (currentIndex + 1) % messages.length;
        return messages[nextIndex];
      });
    }, 3000); // Change content every 3 seconds

    return () => clearInterval(interval);
  });

  //swiper next/prev buttons click cursor blink remove
  document
    .querySelectorAll(".swiper-button-next, .swiper-button-prev")
    .forEach((button) => {
      button.addEventListener("mousedown", (e) => {
        e.preventDefault(); // Prevents focus on click
      });
    });
  //video 
  // const iframeRef = useRef(null);
  // useEffect(() => {
  //   const restartVideo = () => {
  //     if (iframeRef.current) {
  //       const src = iframeRef.current.src;
  //       iframeRef.current.src = ''; // Temporarily clear src to force reload
  //       setTimeout(() => {
  //         iframeRef.current.src = src; // Reset src after a brief delay
  //       }, 100);
  //     }
  //   };
  //   const interval = setInterval(restartVideo, 56000);
  //   return () => clearInterval(interval);
  // }, []);
  // student
  const testimonials = [
    {
      name: "Krish Lakhani",
      grade: "12th Commerce",
      image: s2pic1,
      review:
        "CareerSahi દ્વારા મને ખબર પડી કે Goal કઈ રીતે સેટ થાય અને એના પર કઈ રીતે વર્ક કરી શકાય.",
    },
    {
      name: "Prem Solanki",
      grade: "12th Science",
      image: s2pic2,
      review:
        "મને ખબર જ નહોતી કે આટલી બધી સ્કોલરશીપ અવેઇલેબલ છે. CareerSahi એ મને મારા એજ્યુકેશન અને કરિયર ડેવલપમેન્ટ માટે બેસ્ટ ઓપ્શન શોધવામાં મદદ કરી.",
    },
    {
      name: "Vagadiya Krish",
      grade: "12th Commerce",
      image: s2pic3,
      review:
        "મારી સ્કિલ્સ અને આવડતોને સમજીને CareerSahi એ મને ફિલ્ડ સિલેક્ટ કરવામાં મદદ કરી, હવે હું મારા ફ્યુચરને લઈને ખુબ જ કોન્ફિડન્ટ છું અને મારી પાસે પરફેક્ટ કરિયર રોડમેપ છે.",
    },
    {
      name: "Rucha Chauhan",
      grade: "10th Standard",
      image: s2pic4,
      review:
        "CareerSahi એ મને બીજાને ફોલો કરીને ડિસિઝન લેવાના બદલે આપણામાં રહેલી તાકાતને ઓળખીને ફિલ્ડ ચોઈસ કરવા વિષે સમજાવ્યું. હવે હું જાણું છું કે બેસ્ટ કરિયર માટે બેસ્ટ પ્લાન કઈ રીતે બનાવવો અને એની ઉપર કઈ રીતે વર્ક કરવું.",
    },
    {
      name: "Khushi Vardoriya",
      grade: "10th Standard",
      image: s2pic5,
      review: "Career Counselling માટે CareerSahi એ મારા માટે Best Decision હતું.",
    },
    {
      name: "Gresa Golakiya",
      grade: "12th Commerce",
      image: s2pic6,
      review:
        "ગાઈડન્સ મેળવ્યા પહેલા મારુ પણ એવું જ હતું કે મારી ફ્રેન્ડ્સ જે ફિલ્ડમાં જશે એ જ ફિલ્ડ માં હું જઈશ, પરંતુ હવે મેં CareerSahi દ્વારા પ્રોપર રિસર્ચ કરતા શીખીને વિવિધ ફિલ્ડ્સનુ રિસર્ચ કરી અને મેં મારી ફિલ્ડ સિલેક્ટ કરી છે અને હું એમાં ખુબ જ સારું પરફોર્મન્સ આપી રહી છું.",
    },
  ];
  return (
    <div style={{ minHeight: "100vh" }} className="">
      <section className="home-s1 pb-1 pt-5">
        <div className="container text-center my-1 pt-5 mt-5">
          <div className="fw-semibold head_home mb-3" style={{ color: "rgb(255, 167, 0)", fontSize: "35px" }}>
            India's First{" "}
          </div>
          <p className="des_heading fw-semibold text-white" style={{ fontSize: "35px" }}>
            A School, College & Career Platform for Modern Students
          </p>
        </div>
        <div className="container-fluid my-5">
          <div className="row  justify-content-center">
            <div className="rounded-3 col-xxl-5 col-xl-7 col-md-9 col-11 p-0 m-0 g-0 border_video shadow-lg">
              <video loading="lazy" preload="none" poster={student_image} style={{ display: "block" }} className="p-0 m-0  g-0 col-12 h-100 w-100" playsinline autoPlay loop muted>
                <source src={careersahi_video} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              {/* <iframe
                ref={iframeRef}
                height={450}
                className="w-100 rounded-3 col-xxl-5 col-xl-7 col-md-9 col-11 shadow-lg p-0 g-0"
                src="https://www.youtube.com/embed/QQSylmI9sJY?autoplay=1&mute=1&modestbranding=1&showinfo=0&controls=0"
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe> */}
            </div>
          </div>
        </div>
      </section>

      {/* ------------------------------(Slider)----------------------------------- */}
      <section
        className="slider slider-container home-cs pb-5"
        style={{ background: "#00386D" }}
      >
        {/* <div
          className="view-more-fixed gradient-bar"
          style={{
            height: "100%",
            width: "150px",
            backgroundImage: "linear-gradient(to right, #fff 30%, #ffffff00 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              // transform: "rotate(120deg)",
              display: "block",
              height: "100%",
              textAlign: "center",
              color: "#000",
            }}
          >
            <h6 style={{ margin: 0 }}>View More</h6>
          </div>
        </div> */}

        <Swiper
          slidesPerView={8}
          spaceBetween={20}
          freeMode={true}
          loop={true}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
          }}
          speed={3000}
          freeModeMomentumRatio={-0.0}
          modules={[Autoplay, FreeMode]}
          className="mySwiper pointer"
          breakpoints={{
            // Default (when screen is 320px and up)
            320: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            450: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
            576: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
            775: {
              slidesPerView: 4, // 6 slides when viewport is 775px or wider
              spaceBetween: 20,
            },
            992:{
              slidesPerView: 6,
              spaceBetween: 20,
            },
            1300: {
              slidesPerView: 8,
              spaceBetween: 20,
            },
          }}
        >
          {[
            t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, t12, t13, t14
          ].map((image, index) => (
            <SwiperSlide key={index}>
              <div className="image-container">
                <img className="rounded-3" src={image} alt={`slide-${index}`} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      {/* ----------------------------Students review swiper---------------------------- */}
      <section className="stud-review-main-cls pt-2">
        <Container className="swiper2 pt-3 pb-5">
          <Row className="pt-5">
            <Col xs="12 text-center">
              <div className="pb-3 heading_home fw-bold">Student Testimonial</div>
            </Col>
            <>
              <Swiper
                slidesPerView={3}
                spaceBetween={2}
                loop={true}
                autoplay={{
                  delay: 4000,
                  disableOnInteraction: false,
                }}
                speed={600}
                freeModeMomentumRatio={-0.5}
                navigation={true}
                modules={[Autoplay, Navigation, FreeMode]}
                className="stud-review"
                breakpoints={{
                  320: {
                    slidesPerView: 1,
                  },
                  770: {
                    slidesPerView: 2,
                  },
                  1200: {
                    slidesPerView: 3,
                  },
                }}
              >
                <div className="swp">
                  {testimonials.map((testimonial, idx) => (
                    <SwiperSlide key={idx} className="h-auto">
                      <Card className="border-0 bg-white shadow h-100">
                        <div className="p-4 justify-content-between d-flex flex-column h-100">
                          {/* Quote Image */}
                          <div>
                            <img height={40} src={quto} alt="quote_image" />
                            <div className="border rounded-2 position-relative mt-2 text-center p-3">
                              {/* Profile Image */}
                              <div>
                                <img
                                  src={testimonial.image}
                                  alt="student_image"
                                  className="student_image"
                                  width={100}
                                  height={100}
                                />
                              </div>
                              {/* Review Text */}
                              <div className="pt-5 desc_header mt-2">
                                {testimonial.review}
                                {idx === 0 && (
                                  <>
                                    <br />
                                    Thank You, CareerSahi
                                  </>
                                )}
                              </div>
                            </div>
                          </div>

                          {/* Reviewer Name */}
                          <div className="text-center">
                            <h6 className="mt-3">
                              {testimonial.name}:{" "}
                              <span className="text-muted">{testimonial.grade}</span>
                            </h6>

                            {/* Star Ratings */}
                            <div className="stars mt-2">
                              {[...Array(5)].map((_, index) => (
                                <MdOutlineStarPurple500
                                  color="#FBBC05"
                                  key={index}
                                  className="fs-4"
                                />
                              ))}
                            </div>
                          </div>
                        </div>
                      </Card>
                    </SwiperSlide>
                  ))}
                </div>
              </Swiper>
            </>
          </Row>
        </Container>
      </section>
      {/* about us */}
      <Container fluid className="about_us">
        <Row className="pt-1 justify-content-center">
          <Col lg="11" md="10" xl="10">
            <Row>
              <Col xs="12 text-center">
                <div className="heading_home pb-4 pt-sm-4 fw-bold">About Us</div>
              </Col>
              <Col lg="5" className="justify-content-center d-flex mb-lg-0 mb-3">
                <img className="col-lg-12 col-12 col-md-9 col-sm-10" src={about_image} alt="about_image" />
              </Col>
              <Col md="9" sm="10" xs="12" lg="6" className="d-flex mx-auto flex-column align-items-center justify-content-center">
                <div>
                  <ul className="p-0 gujarati-text m-0" style={{ listStyle: 'none' }}>
                    <li><div style={{ fontSize: '22px', textTransform: 'capitalize', lineHeight: '50px' }}>ભારતનું આધુનિક <span className="fw-semibold" style={{ color: "var(--primary-color)" }}>સચોટ અને નીસ્પક્ષ </span> કરિયર પ્લાનિંગ કરાવતું પ્લેટફોર્મ.</div></li>
                    <li><div style={{ fontSize: '22px', textTransform: 'capitalize', lineHeight: '50px' }}>735 દિવસોનું રિસર્ચ અને <span className="fw-semibold" style={{ color: "var(--primary-color)" }}>250+ ઇન્ડસ્ટ્રી એક્સપર્ટસના</span> સર્વે પછી તૈયાર થયેલું પ્લેટફોર્મ.</div></li>
                    <li><div style={{ fontSize: '22px', textTransform: 'capitalize', lineHeight: '50px' }}>અમેરિકા, ફિનલેન્ડ, અને જાપાન જેવા 10થી વધુ<span className="fw-semibold" style={{ color: "var(--primary-color)" }}> વિકસિત દેશોની એજ્યુકેશન સિસ્ટમ</span> સાથે તૈયાર કરાયેલ એકમાત્ર પ્લેટફોર્મ.</div></li>
                    <li><div style={{ fontSize: '22px', textTransform: 'capitalize', lineHeight: '50px' }}> <span className="fw-semibold" style={{ color: "var(--primary-color)" }}> કરિયર ગાઈડન્સ, મેન્ટોરશીપ, જોબ અને બિઝનેસની તકો</span> જેવા 35+ પેરામીટર તપાસીને સચોટ કરિયર માર્ગદર્શન આપતું એકમાત્ર પ્લેટફોર્મ.</div></li>
                  </ul>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
      {/* card */}
      <Features />
      {/* mentor */}
      <section style={{ background: "#1E2538" }}
        className="slider my-sm-5 pt-5 pb-sm-5 pb-3"
      >
        <div className="text-center">
          <div className="heading_home text-white pb-sm-0  pb-2 fw-bold">Real Insights From Real Experts</div>
          <p style={{ fontSize: '20px' }} className="text-light desc_header col-sm-9  col-11 mx-auto text-center pt-2 pb-4">કરિયરસહી ટીમ દ્વારા અલગ અલગ ઇન્ડસ્ટ્રીના એક્સપર્ટસ પાસેથી માહિતી મેળવે છે, જેથી સચોટ અને રીયલ માહિતીના આધારે વિદ્યાર્થીઓ કરિયરનો નિર્ણય લઇ શકે.</p>
        </div>
        <Swiper
          freeMode={true}
          loop={true}
          spaceBetween={20}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
          }}
          speed={3000}
          freeModeMomentumRatio={-0.0}
          modules={[Autoplay, FreeMode]}
          className="pointer myswiper"
          breakpoints={{
            320: { slidesPerView: 1 },
            410: { slidesPerView: 1.2 },
            500: { slidesPerView: 1.4 },
            580: { slidesPerView: 2 },
            775: { slidesPerView: 2.2 },
            1000: { slidesPerView: 2.8 },
            1200: { slidesPerView: 3.5, spaceBetween: 30 },
            1400: { slidesPerView: 5, spaceBetween: 30 },
          }}
        >
          {[
            mentor1, mentor2, mentor3, mentor4, mentor5, mentor6, mentor7, mentor8, mentor9, mentor10, mentor11, mentor12
          ].map((image, index) => (
            image && (
              <SwiperSlide key={index}>
                <div>
                  <img className="rounded-3 mentor_image" src={image} alt={`slide-${index}`} />
                </div>
              </SwiperSlide>
            )
          ))}
        </Swiper>
        <div className="text-center mt-4">
          <Button style={{ background: "var(--primary-color)" }} onClick={() =>
            navigate('/mentor')
          } className="px-4  border-0 text-white">See All</Button>
        </div>
      </section>
      {/* --------------------------(માર્ગદર્શન Section)----------------------------- */}
      {/* <section className="Content mt-5 mb-5">
        <div className="container">
          <h2 className="text-center">
            <b>
              <span className="fw-bold" style={{ color: "#0B60B1" }}>
                શા માટે
              </span>
              &nbsp;કરિયર માર્ગદર્શનની જરૂર છે??
            </b>
          </h2>
          <div className="mt-5 d-flex row justify-content-center">
            <div className="line1 d-flex align-items-center col-xxl-5">
              <img src={tick} alt="" className="align-items-center" />
              <p className="align-items-center">
                વિદ્યાર્થીની શક્તિઓ, રુચિઓ, નબળાઈઓ શોધી શકાય એ માટે
              </p>
            </div>
            <div className="line1 d-flex align-items-center col-xxl-5">
              <img src={tick} alt="" className="align-items-center" />
              <p className="align-items-center">
                વ્યક્તિગત અને સચોટ કરિયર માર્ગદર્શન મેળવવા માટે
              </p>
            </div>
            <div className="line1 d-flex align-items-center col-xxl-5">
              <img src={tick} alt="" className="align-items-center" />
              <p className="align-items-center">
                યોગ્ય અભ્યાસક્રમ અને કોલેજ પસંદ કરી શકાય એ માટે
              </p>
            </div>
            <div className="line1 d-flex align-items-center col-xxl-5">
              <img src={tick} alt="" className="align-items-center" />
              <p className="align-items-center">
                કઈ યુનિવર્સિટીમાંથી કોલેજ કરવી એ જાણવા માટે
              </p>
            </div>
            <div className="line1 d-flex align-items-center col-xxl-5">
              <img src={tick} alt="" className="align-items-center" />
              <p className="align-items-center">
                યોગ્ય કરિયર ફીલ્ડ શોધી શકાય એ માટે
              </p>
            </div>
            <div className="line1 d-flex align-items-center col-xxl-5">
              <img src={tick} alt="" className="align-items-center" />
              <p className="align-items-center">
                ક્યાં અને કેવી રીતે જોબ મળી શકે એ જાણવા માટે
              </p>
            </div>
            <div className="line1 d-flex align-items-center col-xxl-5">
              <img src={tick} alt="" className="align-items-center" />
              <p className="align-items-center">
                વિદ્યાર્થીના ભવિષ્યની સેફ્ટીનું પ્લાનિંગ અત્યારથી કરી શકાય એ
                માટે
              </p>
            </div>
            <div className="line1 d-flex align-items-center col-xxl-5">
              <img src={tick} alt="" className="align-items-center" />
              <p className="align-items-center">
                જોબ સિવાય પોતાનો વ્યવસાય શરૂ કરવાના વિકલ્પો છે કે કેમ એ જાણવા
                માટે
              </p>
            </div>
            <div className="line1 d-flex align-items-center col-xxl-5">
              <img src={tick} alt="" className="align-items-center" />
              <p className="align-items-center">
                કરિયર માટે પાથ નક્કી કરવા માટે
              </p>
            </div>
            <div className="line1 d-flex align-items-center col-xxl-5">
              <img src={tick} alt="" className="align-items-center" />
              <p className="align-items-center">
                ટેક્નોલોજીના કારણે વારંવાર થતા ફેરફારને કઈ રીતે અપનાવી શકાય એ
                માટે
              </p>
            </div>
            <div className="line1 d-flex align-items-center col-xxl-5">
              <img src={tick} alt="" className="align-items-center" />
              <p className="align-items-center">
                કરિયરની વાસ્તવિકતાઓ સમજવા માટે
              </p>
            </div>
            <div className="line1 d-flex align-items-center col-xxl-5">
              <img src={tick} alt="" className="align-items-center" />
              <p className="align-items-center">
                શિષ્યવૃત્તિના બેસ્ટ વિકલ્પો જાણવા માટે
              </p>
            </div>
            <div className="line1 d-flex align-items-center col-xxl-5">
              <img src={tick} alt="" className="align-items-center" />
              <p className="align-items-center">
                કરિયર પસંદ કરતા પહેલાં કરિયરનો અનુભવ કરવા માટે
              </p>
            </div>
            <div className="line1 d-flex align-items-center col-xxl-5">
              <img src={tick} alt="" className="align-items-center" />
              <p className="align-items-center">
                કરિયર માં સફળ થવા માટે વ્યક્તિગત શું ઈમ્પ્રુવમેન્ટ કરવું પડે એમ
                છે એ જાણવા માટે
              </p>
            </div>
            <div className="line1 d-flex align-items-center col-xxl-5">
              <img src={tick} alt="" className="align-items-center" />
              <p className="align-items-center">
                ભવિષ્યમાં કરિયરની ડિમાન્ડ રહેશે કે નહિ એ જાણવા માટે
              </p>
            </div>
            <div className="line1 d-flex align-items-center col-xxl-5">
              <img src={tick} alt="" className="align-items-center" />
              <p className="align-items-center">
                અત્યાર સુધી શિક્ષણ પાછળ કરેલ પૈસા, સમય અને મહેનતનું મહત્તમ વળતર
                મળી રહે એ માટે
              </p>
            </div>
          </div>
        </div>
      </section> */}

      {/* ------------------------------------------(જરૂરિયાત Section)------------------------------------------ */}
      {/* <section className="boxes-sec container">
        <div className="container my-3 text-center">
          <h2 className="">
            <b>
              શા માટે
              {""} <span className="fw-bold" style={{ color: "#0B60B1" }}>
                CareerSahi
              </span>
              {""} ની જરૂરિયાત છે?
            </b>
          </h2>
          <p>એક સર્વેના ચોંકાવનાર આંકડાઓ પર નજર કરીયે</p>
        </div>
        <div className="d-flex row g-3 justify-content-evenly">
          <div
            className="box1 col-md-5 p-3 text-center"
            style={{ background: "#f7fbf7" }}
          >
            <h4 style={{ color: "#0B60B1" }} className="fw-bold">
              7 લાખ 34 હજાર
            </h4>
            <p>
              વિદ્યાર્થીઓ દર વર્ષે <b>ધોરણ 10</b> માં પ્રવેશ મેળવે છે.
            </p>
          </div>
          <div
            className="box1 col-md-5 p-3  text-center"
            style={{ background: "#fffbf2" }}
          >
            <h4 style={{ color: "#0B60B1" }} className="fw-bold">
              5 લાખ 50 હજાર
            </h4>
            <p>
              વિદ્યાર્થીઓ દર વર્ષે <b>ધોરણ 12</b> માં પ્રવેશ મેળવે છે.
            </p>
          </div>
          <div
            className="box1 col-md-5 p-3 text-center"
            style={{ background: "#f2f8ff" }}
          >
            <h4 style={{ color: "#0B60B1" }} className="fw-bold">
              13.2%
            </h4>
            <p>
              વિદ્યાર્થીઓ જ <b>એક્પર્ટ પાસેથી</b> કરિયર માર્ગદર્શન લઈને કરિયર
              પસંદગી કરે છે.
            </p>
          </div>
          <div
            className="box1 col-md-5 p-3 text-center"
            style={{ background: "#fff7f7" }}
          >
            <h4 style={{ color: "#0B60B1" }} className="fw-bold">
              86.8%
            </h4>
            <p>
              વિદ્યાર્થીઓ <b>મિત્રવર્તુળને</b> ધ્યાનમાં રાખીને કરિયર પસંદગી કરે
              છે.
            </p>
          </div>
          <div
            className="box1 col-md-5 p-3 text-center"
            style={{ background: "#faf7ff" }}
          >
            <h4 style={{ color: "#0B60B1" }} className="fw-bold">
              78%
            </h4>
            <p>
              વિદ્યાર્થીઓ <b>અપૂરતા માર્ગદર્શનના </b> કારણે કરિયરમાં સફળ નથી થઇ
              શકતા.
            </p>
          </div>
          <div
            className="box1 col-md-5 p-3 text-center"
            style={{ background: "#f4f9fb" }}
          >
            <h4 style={{ color: "#0B60B1" }} className="fw-bold">
              83%
            </h4>
            <p>
              વિદ્યાર્થીઓ પાસે કરિયરનો કોઈ <b>સચોટ પ્લાન</b> નથી હોતો.
            </p>
          </div>
        </div>
      </section> */}

      {/* ---------------------------(Sagarsir Youtube)-------------------------------- */}
      <section className="s-youtube">
        <div className="container">
          <div className="row justify-content-center align-items-center d-flex flex-wrap">
            <div className="col-xl-5 col-md-8  col-lg-6 col-sm-10 col-12">
              <h1 className="pt-sm-5 pt-3  mb-4">
                <b>
                  {" "}
                  હાલ ની કરિયર પસંદ કરવાની{" "}<br />
                  <span className="fw-bold" style={{ color: "#0B60B1" }}>
                    ખોટી અને ખતરનાક પદ્ધતિ{" "}
                  </span>
                </b>
              </h1>
              <div className="cont">
                <div className="line1 d-flex">
                  <img src={cross} alt="cros-png" />
                  <p>ફ્રેન્ડ સર્કલને ધ્યાનમાં રાખીને</p>
                </div>
                <div className="line1 d-flex">
                  <img src={cross} alt="cros-png" />
                  <p>કરિયરનું ઊંડાણપૂર્વક નોલેજ ના હોય તોપણ</p>
                </div>
                <div className="line1 d-flex">
                  <img src={cross} alt="cros-png" />
                  <p>સગા સબંધીના અધૂરા સલાહ સૂચનથી</p>
                </div>
                <div className="line1 d-flex">
                  <img src={cross} alt="cros-png" />
                  <p>માત્ર સેલેરી કે આવક જોઈને</p>
                </div>
                <div className="line1 d-flex">
                  <img src={cross} alt="cros-png" />
                  <p>માતા પિતા કે અન્ય લોકોના દબાણમાં આવીને</p>
                </div>
                <div className="line1 d-flex">
                  <img src={cross} alt="cros-png" />
                  <p>
                    <b className="fw-semibold">"ઓછા સમય માં વધુ પગાર"</b> આવી મોટી મોટી વાતોથી અંજાઈને
                  </p>
                </div>
              </div>
            </div>
            <div className="SV text-center pt-5 col-lg-6">
              <img className="col-xl-12 col-lg-12 col-md-8 col-sm-10 col-12 rounded-3"
                src={sv}
                alt="Click to play video"
                onClick={() => openVideo("https://www.youtube.com/embed/WiuUMQI2vY4")}
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>
        </div>
      </section>
      {/* career Counselling  */}
      <div className="pb-4">
        <Container fluid style={{ background: "rgb(249,203,75)" }} className="my-sm-5 py-5 counselling_section">
          <Row className="justify-content-center">
            <Col xl="11">
              <div className="py-4">
                <div className="d-flex pb-sm-5 pb-3 justify-content-between">
                  <img className="opacity-25 d-none w-auto d-sm-block" src={warning} alt="warning" />
                  <h2 className="align-self-center  fw-semibold">શા માટે કરિયર પ્લાનિંગ જરૂરી છે?</h2>
                </div>
                <Row className="g-3 justify-content-center p-0">
                  <Col sm="6" md="4">
                    <div className="bg-white  h-100  rounded-4 p-4 border-0">
                      <div className="fs-4" style={{ letterSpacing: "1px" }}>અઢળક હરીફાઈ</div>
                      <img className="mt-4 mb-5" height={50} width={90} src={graduactions} alt="graduactions" />
                      <div className="d-flex flex-column cr">
                        <div>અમેરિકાની કુલ વસ્તી <img height={30} width={30} src={usa} alt="usa" /> </div>
                        <div className="fw-bold">33 Cr.</div>
                      </div>
                      <div className="d-flex flex-column cr  mt-4">
                        <div>2030 સુધીમાં ભારતમાં ગ્રેજ્યુએટ વિદ્યાર્થીઓ<img className="ms-2" width={30} height={30} src={india} alt="india" /> </div>
                        <div className="fw-bold">35 Cr.</div>
                      </div>
                    </div>
                  </Col>
                  <Col sm="6" md="4">
                    <div className="bg-white h-100 rounded-4 p-4 border-0">
                      <div className="fs-4" style={{ letterSpacing: "1px" }}>એક રિસર્ચ પ્રમાણે</div>
                      <img className="my-4" height={90} width={90} src={running} alt="graduactions" />
                      <div className="counselling_text">આમાંથી<span className="fw-bold"> 65%</span> <br></br>ભારતના ગ્રેજ્યુએટ <span className="fw-bold">બેરોજગાર</span> હશે</div>
                    </div>
                  </Col>
                  <Col sm="6" md="4">
                    <div className="bg-white h-100 rounded-4 p-4 border-0">
                      <div className="fs-4" style={{ letterSpacing: "1px" }}>પરંતુ શા માટે?</div>
                      <img className="my-4" height={90} width={90} src={thinking} alt="thinking" />
                      <div className="counselling_text"><span className="fw-bold">90%</span> વિદ્યાર્થીઓ <br></br>માત્ર <span className="fw-bold"> 7 કરિયર ઓપ્શન</span> થી જ વાકેફ છે</div>
                    </div>
                  </Col>
                </Row>
                <div className="d-flex pt-sm-5 pt-3 mt-sm-5 pb-3 justify-content-between">
                  <div style={{ fontWeight: "400", lineHeight: '2rem' }} className="fs-4 col-xxl-6 col-sm-10 col-12 desc_header">કરિયરસહી પ્લેટફોર્મ પર  <span className="fw-bold">250+</span> કારકિર્દી વિકલ્પો, <span className="fw-bold">600+</span> સ્કોલરશીપ, <span className="fw-bold">25,000+</span> કોલેજો છે જે તમને
                    આર્થિક રીતે મજબૂત ભવિષ્ય બનાવવામાં મદદ કરી શકે છે.<br />

                    <span className="fw-bold">તમે કેટલાથી વાકેફ છો?</span></div>
                  <img alt="downArrow" className="opacity-25 d-none d-sm-block w-auto"  src={down_arrow} />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      {/* -------------------------------(Canvas Section)--------------------------------------
      <section className="canvas my-5 py-4">
        <Container className="d-flex justify-content-center">
          <Row>
            <Col xs="12" lg="6" className="d-flex justify-content-center">
              <img style={{ objectFit: 'contain' }} src={canvas} alt="canvas-pic-stud" className="col-12" />
            </Col>
            <Col xs="12" lg="6">
              <p className="mx-3 mt-4">હવે બનશે</p>
              <h3 className="mx-3">
                <b>
                  <span className="fw-bold" style={{ color: "#0B60B1" }}>
                    કરિયર સહી</span>
                  {""}  દ્વારા વિદ્યાર્થીઓનું સાચું કરિયર
                </b>
              </h3>
              <Row className="mt-3">
                {features.map((feature, index) => (
                  <Col
                    key={index}
                    xs="12"
                    sm="6"
                    xl="5"
                    className="d-flex align-items-center mb-2"
                  >
                    <img height={30} src={tick} alt="tick" className="me-2" />
                    <p className="mb-0">{feature}</p>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </Container>
      </section> */}

      {/* --------------------------(testimonials Stud Youtube)------------------------------- */}
      <section className="testimonials-stud home-cs pb-5">
        <Swiper
          slidesPerView={5}
          spaceBetween={20}
          freeMode={true}
          loop={true}
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
          }}
          speed={3000}
          freeModeMomentumRatio={-0.0}
          modules={[Autoplay, FreeMode]}
          className="mySwiper"
          breakpoints={{
            // Default (when screen is 320px and up)
            320: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            385: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            576: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1000: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
            1300: {
              slidesPerView: 5,
              spaceBetween: 20,
            },
          }}
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
        >
          {[
            {
              src: studvideo1,
              videoUrl:
                "https://www.youtube.com/embed/tOjg1DNEUz8?si=V8SSYNDAYAI72bDr&start=41",
            },
            {
              src: studvideo2,
              videoUrl:
                "https://www.youtube.com/embed/e-4iwDlkbOE?si=DcN1smCXLfggOveg&start=2",
            },
            {
              src: studvideo3,
              videoUrl:
                "https://www.youtube.com/embed/pCuX9dq_pc4?si=HsyDWXXDFI9AQB8p",
            },
            {
              src: studvideo4,
              videoUrl:
                "https://www.youtube.com/embed/QFlJhskTMZI?si=gO1WAq-Y8aV63dEz",
            },
            {
              src: studvideo5,
              videoUrl:
                "https://www.youtube.com/embed/KwHpYUQ0HwE?si=1W4iMHaqrYmCuV0V",
            },
            {
              src: studvideo6,
              videoUrl:
                "https://www.youtube.com/embed/wQ8t9CU2b-8?si=24JedpsY0PXtytzG",
            },
            {
              src: studvideo7,
              videoUrl:
                "https://www.youtube.com/embed/RvryU3Hcatg?si=QvfYeEvFkYTe1SZu",
            },
            {
              src: studvideo8,
              videoUrl:
                "https://www.youtube.com/embed/Oh0FJYmByew?si=QRUzHzDmDX39diNK",
            },
            // Add more video data here...
          ].map((item, index) => (
            <SwiperSlide key={index}>
              {isswiper_img !== index && (
                <img className="col-12"
                  src={item.src}
                  alt="Click to play video"
                  // onClick={() => swiper_img(index)}
                  onMouseEnter={() => swiperRef.current.autoplay.stop()}
                  onMouseLeave={() => swiperRef.current.autoplay.start()}
                  style={{ cursor: "pointer", objectFit: "contain" }}
                  onClick={() => openVideo(item.videoUrl)}
                />
              )}
            </SwiperSlide>
          ))}
        </Swiper>
        {/* pop up */}
        {videoboxOpen && (
          <>
            <div className="lightboxx">
              <div className="video-container">
                <span className="close-lightboxer" onClick={closeVideo}>×</span>
                <iframe key={currentVideo}
                  src={currentVideo}
                  title="YouTube video player"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </>
        )}
      </section>

      {/* -------------------------------(સચોટ માર્ગદર્શનના 5 પગથિયાં)------------------------------- */}
      {/* <section className="imgs5">
        <div className="container">
          <h3 className="text-center">
            <b>
              સચોટ માર્ગદર્શનના{" "}
              <span className="fw-bold" style={{ color: "#0B60B1" }}>
                5 પગથિયાં
              </span>
            </b>
          </h3>
          <div className="text-center">
            <img className="col-md-10 col-sm-11 col-12" src={fivestep} alt="" />
          </div>
        </div>
      </section> */}
      {/* career counselling important */}
      {/* -------------------------------------------------------------------------- */}
      <Container className="drpdown col-xl-7 my-4">
        <h2 className="text-center pb-4 fw-bold">
          વારંવાર થતા પ્રશ્નો અને જવાબો
        </h2>
        <Accordion activeKey={activeKey} className="">
          <Accordion.Item eventKey="1" className="justify-content-between p-3">
            <Accordion.Header
              onClick={() => toggleAccordion("1")}
              className="text px-0"
            >
              CareerSahi શું છે?
            </Accordion.Header>
            <Accordion.Body className="text1 p-0">
              CareerSahi એ એક કારકિર્દી માર્ગદર્શન નેટવર્ક છે જે ધોરણ 10 અને
              12ના વિદ્યાર્થીઓને તેમની ભવિષ્યની કારકિર્દીઓની પસંદગીમાં મદદ કરે
              છે.
            </Accordion.Body>
          </Accordion.Item>
          {/* <hr /> */}
          <Accordion.Item eventKey="2" className="p-3">
            <Accordion.Header
              onClick={() => toggleAccordion("2")}
              className="text"
            >
              મારી કારકિર્દી માટે માર્ગદર્શન કેમ જરૂરી છે?
            </Accordion.Header>
            <Accordion.Body className="text1 p-0">
              યોગ્ય કારકિર્દી પસંદ કરવી તમારા આખા જીવન પર અસર કરી શકે છે.
              CareerSahi તમને તમારી રુચિઓ, કુશળતાઓ, આવડત અને ક્ષમતાના આધારે સાચી
              કારકિર્દી શોધવામાં મદદ કરશે.
            </Accordion.Body>
          </Accordion.Item>
          {/* <hr /> */}
          <Accordion.Item eventKey="3" className="p-3">
            <Accordion.Header
              onClick={() => toggleAccordion("3")}
              className="text"
            >
              કારકિર્દી માર્ગદર્શન માટે CareerSahi શું સેવાઓ આપે છે?
            </Accordion.Header>
            <Accordion.Body className="text1 p-0">
              કરિયરસહી વ્યક્તિગત વિદ્યાર્થીનું કારકિર્દી માર્ગદર્શન, કોલેજ
              એડમિશન હેલ્પ, કરિયર પ્લાંનિંગ અને સ્કોલરશીપ સહિતની સર્વિસ આપે છે.
            </Accordion.Body>
          </Accordion.Item>
          {/* <hr /> */}
          <Accordion.Item eventKey="4" className="p-3">
            <Accordion.Header
              onClick={() => toggleAccordion("4")}
              className="text p-0"
            >
              કરિયરસહીની સર્વિસ Free છે કે Paid?
            </Accordion.Header>
            <Accordion.Body className="text1 p-0">
              કરિયરસહીની અમુક સર્વિસ ફ્રી છે જયારે અમુક પ્રીમિયમ સર્વિસ Paid છે
              જે દરેક વિદ્યાર્થી ને પોસાય એવી છે.
            </Accordion.Body>
          </Accordion.Item>
          {/* <hr /> */}
          <Accordion.Item eventKey="5" className="p-3">
            <Accordion.Header
              onClick={() => toggleAccordion("5")}
              className="text"
            >
              CareerSahi નું કોઈ ઇન્સ્ટિટ્યૂટ કે કોલેજ સાથે tie-up છે?
            </Accordion.Header>
            <Accordion.Body className="text1 p-0">
              કરિયરસહી ખાસ કરીને વિદ્યાર્થીઓને સચોટ, સંપૂર્ણ અને નિષ્પક્ષ
              માર્ગદર્શન પૂરું પાડવા માટેની એક પહેલ છે જે કોઈ કોલેજ કે
              ઇન્સ્ટિટ્યૂટની તરફેણ કર્યા વિના માર્ગદર્શન પૂરું પાડે છે.
            </Accordion.Body>
          </Accordion.Item>
          {/* <hr /> */}
        </Accordion>
      </Container>
      {/* contact */}
      <div className="counseller_contact mt-5 pt-sm-5">
        <Container fluid style={{ background: "#1E2538" }}>
          <Row className="justify-content-center">
            <Col lg="11" xl="10" xxl="7" className="py-5">
              <div className="py-sm-5 py-3 justify-content-center  d-flex flex-md-nowrap flex-wrap align-items-center justify-content-sm-between">
                <div className="d-flex flex-sm-nowrap justify-content-center text-center text-sm-start flex-wrap">
                  <div className="text-center justify-content-center  col-sm col-12">
                    <img src={vidhi} alt="meena" className="align-self-center counsellor_image rounded-circle" />
                  </div>
                  <div className="text-white ps-sm-5">
                    <div className="fs-4 fw-bold counseling_title">Vidhi Kachhadiya</div>
                    <div className="fs-4 counseling_desc py-sm-2">Customer Support Manager - CareerSahi</div>
                    <div className="fs-4  pointer"><Link className="counseling_desc text-white" to={"tel:+91-+91-82382-35437"}>+91-82382-35437</Link></div>
                    <div className="py-sm-2 fs-4"><Link to="mailto:aman.ajudiya@careersahi.com" className="text-decoration-none counseling_desc pointer text-white">
                      info@careersahi.com
                    </Link></div>
                  </div>
                </div>
                <div className="text-center mt-sm-0 mt-2 ms-md-0 ms-sm-auto me-sm-3">
                  <div className="fs-4 text-white fw-bold">Contact Us</div>
                  <Link target="_blank" to="https://api.whatsapp.com/send/?phone=8238235437&text=Hello CareerSahi&type=phone_number&app_absent=0">
                    <button className="px-md-4 px-3 mt-sm-3 mt-1 d-flex fs-5 align-items-center rounded-1 whats_button  border-0 py-2 text-white">
                      <FaWhatsapp className="fs-5 mt-1 align-self-center me-2 " />
                      Chat on WhatsApp
                    </button>
                  </Link>
                </div>
              </div>
            </Col>
            <button style={{ height: "18px" }} className="bg-white col-12 mb-2 border-0"></button>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default Home;
